import { useState } from "react";
import { useDispatch } from "react-redux";
import { PollActions } from "@Store";
import { CommentActions } from "@Interfaces/Entities/Poll";
interface IUseCommentItem {
    channelId: string;
    pollId: string;
    commentId: string;
    setActiveComment: any;
}

export const useCommentItem = ({
    channelId,
    pollId,
    commentId,
    setActiveComment,
}: IUseCommentItem) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const dispatch = useDispatch<any>();

    const handelOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleEditComment = () => {
        setActiveComment({
            id: commentId,
            commentTargetAction: CommentActions.EDITING,
        });
        handleClose();
    };

    const handleDeleteComment = async () => {
        dispatch(PollActions.deleteComment(channelId, pollId, commentId));
        handleClose();
    };

    return {
        handelOpenMenu,
        handleClose,
        handleEditComment,
        handleDeleteComment,
        anchorEl,
    };
};
